import { AxiosError } from 'axios';

/** Error code returned by the API when an organization's uploads are suspended. */
export const UPLOAD_SUSPENDED_ERROR = 'organization-upload-suspended';

/**
 * True when the API refused the request because the organization may not start
 * new credit-consuming work.
 *
 * Entitlements are cached, so a user can still reach an upload in the window
 * between a suspension landing and the next entitlements fetch. Detect it to
 * show the real reason instead of the raw error code.
 */
export function isUploadSuspendedError(error: unknown): error is AxiosError {
  if (!(error instanceof Error) || !('isAxiosError' in error)) return false;
  const ax = error as AxiosError<{ error?: string }>;
  return (
    ax.response?.status === 403 &&
    ax.response?.data?.error === UPLOAD_SUSPENDED_ERROR
  );
}
